import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import type { RouteParams } from '../configs/route.config';
import { DEFAULT_SESSION_CONFIG_KEY } from '../constants/common.constant';
import { createSafeSessionId } from '../utils/common.utils';
import useCurrentContext from './useCurrentContext';
import useSearchParams from './useSearchParams';

// TODO: SDPCCPLT-808 - update this hook to not use magic booleans as params
const useSessionId = (
  withCurrentContext?: boolean,
  withSearchParams?: boolean
): string => {
  const params = useParams<RouteParams>();
  const currentContext = useCurrentContext();
  const searchParams = useSearchParams();

  const contextSessionId = useMemo(
    () =>
      withCurrentContext
        ? currentContext?.fleetsId ||
          currentContext?.hubsId ||
          currentContext?.organizationsId
        : undefined,
    [
      currentContext?.fleetsId,
      currentContext?.hubsId,
      currentContext?.organizationsId,
      withCurrentContext,
    ]
  );

  const searchParamsSessionId = useMemo(
    () =>
      withSearchParams
        ? searchParams?.assetsId ||
          searchParams?.fleetsId ||
          searchParams?.hubsId ||
          searchParams?.organizationsId
        : undefined,
    [
      searchParams?.assetsId,
      searchParams?.fleetsId,
      searchParams?.hubsId,
      searchParams?.organizationsId,
      withSearchParams,
    ]
  );

  const sessionId = useMemo(() => {
    const id =
      contextSessionId ||
      searchParamsSessionId ||
      params?.assetsId ||
      params?.fleetsId ||
      params?.hubsId ||
      params?.organizationsId ||
      DEFAULT_SESSION_CONFIG_KEY;
    return id;
  }, [
    contextSessionId,
    params?.assetsId,
    params?.fleetsId,
    params?.hubsId,
    params?.organizationsId,
    searchParamsSessionId,
  ]);

  // Validate sessionId to prevent prototype pollution
  const safeSessionId = useMemo(
    () => createSafeSessionId(sessionId),
    [sessionId]
  );

  return safeSessionId;
};

export default useSessionId;
